import { render, staticRenderFns } from "./branch-office-view.vue?vue&type=template&id=1504a6ce&"
import script from "./branch-office-view.vue?vue&type=script&lang=js&"
export * from "./branch-office-view.vue?vue&type=script&lang=js&"
import style0 from "./branch-office-view.vue?vue&type=style&index=0&id=1504a6ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports